import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InvoiceStatusComponent } from './invoice-status.component';

@NgModule({
  declarations: [ InvoiceStatusComponent ],
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  exports: [ InvoiceStatusComponent ]
})
export class InvoiceStatusModule {
}
